import { LORRY_CATEGORIES_ENUM } from "@vahak/core/dist/constants/lorryTypes";

import { QuoteFormFieldId } from "./validateQuoteForm";

export const QUOTE_FORM_LCV_LORRY_TYPE = LORRY_CATEGORIES_ENUM.LCV;

export const HERO_LOAD_QUOTE_FIELD_IDS: Record<QuoteFormFieldId, string> = {
    "quote-pickup-city": "quote-pickup-city",
    "quote-drop-city": "quote-drop-city",
    "quote-tonnes": "quote-tonnes"
};

export const ROUTE_LOAD_QUOTE_FIELD_IDS: Record<QuoteFormFieldId, string> = {
    "quote-pickup-city": "compact-route-pickup-city",
    "quote-drop-city": "compact-route-drop-city",
    "quote-tonnes": "compact-load-details-tonnes"
};

/** Compact route step validates pickup + drop only; capacity is collected on load details. */
export const ROUTE_QUOTE_SKIP_CAPACITY_VALIDATION = {
    skipCapacityValidation: true
} as const;

export type LoadQuoteFormVariant = "hero" | "routeStep";
